import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig,
         DwMetaDataFormApi, DwMetaDataFormStateService, DwEventService } from '@devwareapps/devware-cap';
import { StarRatingComponent } from 'ng-starrating';
import { Observable, Subscription, of } from 'rxjs';

@DwComponent({
  key: 'wachter-star-rating-control',
  name: 'Wachter Star Rating',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-wachter-star-rating-control',
  templateUrl: './wachter-star-rating-control.component.html',
  styleUrls: ['./wachter-star-rating-control.component.scss']
})
export class WachterStarRatingControlComponent implements DwFormControl , DwFormControlInit{
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  context: DwContext;
  useDisplayField?: boolean;
  formApi: DwMetaDataFormApi;
  subscriptions: Subscription[] = [];

  UPDATE_TOPIC = 'UPDATE-RATING-';

  constructor(private dwFormStateService: DwMetaDataFormStateService,
              private dwEventService: DwEventService
              ) 
  {
    this.formApi = dwFormStateService.state.formApi;
  }

  ratingValue: number = 0;
  ratingTitle: string = "";
  settings = {
    "value": this.ratingValue,
    "totalStars": 4,
    "checkedColor": "gold",
    "uncheckedColor": "lightgray",
    "size": "40px",
    "readOnly": false
  }

  
  initControl(): void {
    // More checks needed since the data might not be loaded yet
    this.ratingValue = this.RatingControl.value;
  }

  ngOnInit() {
    this.ratingValue = this.RatingControl.value;
    this.subscriptions.push(
      this.dwEventService.getEventData<number>(this.UPDATE_TOPIC + this.fieldDef.attrName)
                         .subscribe(data => this.update(data))
    );
    this.subscriptions.push(
      this.formApi.getFormDataChanges(100).subscribe(p => {
        this.settings.readOnly = this.fieldDef?.isReadOnly || false;
      })
    );
  }

  onRate($event:{oldValue:number, newValue:number, starRating:StarRatingComponent}) {
    this.update($event.newValue);
  }
  update(val:number){
    this.ratingValue = val;
    this.RatingControl.setValue(val);
  }

  /*
   * Returns the rating Form Control to get or set it's value
   */
  get RatingControl(): AbstractControl {
    return this.formGroup.get(this.fieldDef.attrName);
  }

}
